<template>
  <v-snackbar
      :value="isopen"
      timeout="3000"
      :color="color"
      top
      right
    >
      {{ text }}
      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
          >OK</v-btn
        >
      </template> -->
    </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  data() {
    return {
      snackbar: true,
      // text: `Hello, I'm a snackbar`,
    };
  },
  props: {
    color: {
      default: () => ({}),
    },
    text: {
      default: () => ({}),
    },
    isopen: {
      default: () => ({}),
    },
  },
}
</script>

<style>

</style>